import React from 'react'
import styled from 'styled-components'

import Section from '../Section/Section'
import background from '../../images/hero.png'

const Title = styled.h1`
    text-align: center;
    font-family: BankGothic;
    font-size: 70px;
    margin-bottom:20px;
    line-height: 0px;
    display: flex;
    color: #e67f0d;
    text-shadow: 3px 0px 7px rgba(81,67,21,0.8), -3px 0px 7px rgba(81,67,21,0.8), 0px 4px 7px rgba(81,67,21,0.8);

 `

const Subtitle = styled.p`
    text-align: center;
    display: flex;
    font-size: 30px;
`

const Background = styled.div`
    display: flex;
    flex-align: column;
    width: 100%;
    height: 550px;
    background-image: url(${background});
    background-size: cover;
    background-position: center;
`

const Hero = () => {

    return (
        <Background>
            <Section direction={"column"} align={"center"} justify={""}>
                <Title>RYKLIN OY</Title>
                <Subtitle>Koneurakointia laajalla rintamalla</Subtitle>
            </Section>
        </Background>
    )
}

export default Hero